import type { ReactElement } from "react";
import { CmtsOrganizationAdminContainer } from "../../core/containers/domain/administrationRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsOrganizationAdminContainer runtime={props.runtime} />;
}

export default Component;
